import { appConfig } from "../../InitData";

function importBetradarS5CSS() {
    const link = document.createElement('link');
	link.rel = 'preload';
	link.href = `${appConfig.PUBLIC_URL || window.XSPORT_PUBLIC_URL}/assets/css/br-widget-s5.css`;
    link.as = 'style';
    link.onload = function() {
        this.onload=null;
        this.rel='stylesheet';
    };
	const node = document.getElementsByTagName('link')[0];
	node.parentNode.insertBefore(link, node);
}

export function initBetradarWidgetS5(url, language, callback = null) {
    importBetradarS5CSS();
    (function(a,b,c,d,e,f,g,h,i){const s5_script = (a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date(),i.o=f,
    g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),g.onload=callback,h.parentNode.insertBefore(g,h)
    ))})(window,document,'script', url, 'SIR', {
    theme: false, // using custom theme
    language: language && language.toLowerCase()
    });
}
